
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[postID]",
      function () {
        return require("private-next-pages/posts/[postID].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/[postID]"])
      });
    }
  